export default {
  methods: {
    successMessage(message, callback) {
      const vm = this

      vm.$swal({
          title: 'Success',
          text: message,
          icon: 'success',
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: 'Close',
          customClass: {
            container: 'z-[99999999]'
          }
      }).then((result) => {
          if (result.isConfirmed) {
            if (typeof callback == 'function') {
              callback()
            }
            vm.$swal.close();
          }
      });
    },
    errorMessage(title, message, callback) {
      const vm = this

      vm.$swal({
          title: title,
          html: message,
          icon: 'error',
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: 'Close',
          customClass: {
            container: 'z-[99999999]'
          }
      }).then((result) => {
          if (result.isConfirmed) {
            if (typeof callback == 'function') {
              callback()
            }
            vm.$swal.close();
          }
      });
    },
  }
}
